import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useStateContext } from "../../Contexts/ContextProvider";
import TenantBadge from "../auth/TenantBadge";
import ConferenceDropdown from "../../Forms/ConferenceDropdown";
import "../sidebar/nav.css";

const Navbar = ({ isMobileNavOpen, onMobileNavToggle }) => {
  const location = useLocation();
  const { user, tenant } = useStateContext();
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const userMenuRef = useRef(null);
  const pathArray = location.pathname.split("/").filter(Boolean);

  const formatSegment = (segment) => {
    if (!segment) return "Home";
    return segment
      .replace(/-/g, " ")
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const displayName = user?.name || "Admin";
  const currentTitle = pathArray.length ? formatSegment(pathArray[pathArray.length - 1]) : "Dashboard";

  useEffect(() => {
    if (!isUserMenuOpen) return undefined;

    const closeOnOutsideClick = (event) => {
      if (!userMenuRef.current?.contains(event.target)) setIsUserMenuOpen(false);
    };
    const closeOnEscape = (event) => {
      if (event.key === "Escape") setIsUserMenuOpen(false);
    };

    document.addEventListener("pointerdown", closeOnOutsideClick);
    document.addEventListener("keydown", closeOnEscape);
    return () => {
      document.removeEventListener("pointerdown", closeOnOutsideClick);
      document.removeEventListener("keydown", closeOnEscape);
    };
  }, [isUserMenuOpen]);

  useEffect(() => setIsUserMenuOpen(false), [location.pathname]);

  return (
    <header className=" navbar navbar-main modern-navbar" id="navbarBlur" style={{ padding : "0.5rem 1rem" }} aria-label="Main navigation">
      <div className="navbar-context">
        <button
          type="button"
          className="mobile-nav-toggle"
          onClick={onMobileNavToggle}
          aria-label={isMobileNavOpen ? "Close navigation" : "Open navigation"}
          aria-expanded={isMobileNavOpen}
          aria-controls="sidenav-main"
        >
          <i className="material-icons" aria-hidden="true">{isMobileNavOpen ? "close" : "menu"}</i>
        </button>
        <div className="navbar-heading">
          {pathArray.length > 1 && (
            <p className="navbar-breadcrumb">{pathArray.slice(0, -1).map(formatSegment).join(" / ")}</p>
          )}
          <div className="navbar-heading__line">
            <h1 className="navbar-title" aria-current="page">{currentTitle}</h1>
            <TenantBadge tenant={tenant} />
          </div>
        </div>
      </div>

      <ConferenceDropdown compact />

      <div className="navbar-actions">
        <div className="user-menu" ref={userMenuRef}>
          <button
            type="button"
            className="user-pill user-menu__trigger"
            title="Manage your account"
            aria-label={`Account menu for ${displayName}`}
            aria-haspopup="true"
            aria-expanded={isUserMenuOpen}
            aria-controls="user-account-menu"
            onClick={() => setIsUserMenuOpen((open) => !open)}
          >
            <span className="user-pill__avatar" aria-hidden="true">{displayName.charAt(0).toUpperCase()}</span>
            <span className="user-pill__details">
              <span className="user-pill__name">{displayName}</span>
              <span className="user-pill__role">Admin</span>
            </span>
            <i className="material-icons user-menu__chevron" aria-hidden="true">{isUserMenuOpen ? "expand_less" : "expand_more"}</i>
          </button>

          {isUserMenuOpen && (
            <nav className="user-menu__dropdown" id="user-account-menu" aria-label="Account options">
              <Link to="/Account/View" onClick={() => setIsUserMenuOpen(false)}>
                <i className="material-icons" aria-hidden="true">person</i>
                <span>Profile</span>
              </Link>
              <Link to="/Account/edite" onClick={() => setIsUserMenuOpen(false)}>
                <i className="material-icons" aria-hidden="true">manage_accounts</i>
                <span>Account details</span>
              </Link>
              <Link to="/Account/Settings" onClick={() => setIsUserMenuOpen(false)}>
                <i className="material-icons" aria-hidden="true">settings</i>
                <span>Settings &amp; password</span>
              </Link>
              <div className="user-menu__divider" aria-hidden="true" />
              <Link to="/logout" onClick={() => setIsUserMenuOpen(false)}>
                <i className="material-icons" aria-hidden="true">logout</i>
                <span>Sign out</span>
              </Link>
            </nav>
          )}
        </div>
      </div>
    </header>
  );
};

export default Navbar;
